module.exports = __webpack_public_path__ + "img/metamask_one.5aa32ac2.png";